<template>
  <b-modal
    ref="modal"
    :title="$t('common.request_creation')"
    modal-class="spdo-modal"
    hide-header-close
    hide-footer
    centered
    size="sm"
    @hide="$emit('input', false)"
  >
    <v-form @submit.prevent="submit">
      <div class="v-application spdo-modal__body pt-4">
        <div class="input-block input-block_white">
          <label class="input-block__label">
            {{ $t('common.subject') }}
          </label>
          <v-text-field
            v-model="request.subject"
            autocomplete="off"
            hide-details
            required
            solo
          />
        </div>
        <div class="input-block input-block_white">
          <label class="input-block__label">
            {{ $t('common.comment') }}
          </label>
          <v-textarea
            v-model="request.message"
            autocomplete="off"
            hide-details
            solo
          />
        </div>
      </div>
      <div class="v-application d-flex">
        <v-btn
          color="primary"
          class="mr-4 flex-grow-1"
          :loading="loading"
          outlined
          large
          type="submit"
          :disabled="submitDisabled || loading"
        >
          <v-icon
            left
          >
            mdi-plus
          </v-icon>
          {{ $t('common.create_request') }}
        </v-btn>
        <v-btn
          class="flex-grow-1"
          outlined
          large
          @click="$refs.modal.hide()"
        >
          {{ $t('common.cancel') }}
        </v-btn>
      </div>
    </v-form>
  </b-modal>
</template>

<script>
export default {
  name: 'CreateRequestModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loading: false,
    request: {
      subject: '',
      message: '',
    },
  }),
  computed: {
    submitDisabled() {
      return !this.request.subject || !this.request.message;
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.updateForm();
        this.$refs.modal.show();
      } else {
        this.$emit('input', false);
      }
    },
  },
  methods: {
    updateForm() {
      Object.assign(this.$data.request, this.$options.data().request);
    },
    async submit() {
      this.loading = true;

      await this.$http.post('requests', this.request).finally(() => {
        this.loading = false;
      });
      this.$refs.modal.hide();
      this.$emit('submit');
    },
  },
};
</script>
